const GET_ANSWERS_BY_SESSION_REQUEST = "GET_ANSWERS_BY_SESSION_REQUEST";
const GET_ANSWERS_BY_SESSION_COMPLETED = "GET_ANSWERS_BY_SESSION_COMPLETED";
const GET_ANSWERS_BY_SESSION_ERROR = "GET_ANSWERS_BY_SESSION_ERROR";

export default {
  GET_ANSWERS_BY_SESSION_REQUEST,
  GET_ANSWERS_BY_SESSION_COMPLETED,
  GET_ANSWERS_BY_SESSION_ERROR
}
